import React from 'react';
import PromotionalHome from '../components/displays/PromotionalHome';

const Home = () => {
  return <PromotionalHome />;
};

export default Home;